import List from '../../../generic/List';
import type { OnBranchChangeFn, OnSelectRepositoryFn } from './types';
import styles from './index.module.less';
import type { Repository } from '../../../../types';
import UnimportedProjectRow from './UnimportedProjectRow';
import ImportedProjectRow from './ImportedProjectRow';
import ConnectableProjectRow from './ConnectableProjectRow';

export type HybridProjectsServiceImportRepositoriesTableProps = {
  repositories: Repository[];
  onBranchChange: OnBranchChangeFn;
  selectedRepos: Repository[];
  onSelectRepository: OnSelectRepositoryFn;
};

/**
 * A table component just for hybrid-project imports
 *
 * repositories - Row data for the table
 */
const HybridProjectsTable = ({
  repositories,
  onBranchChange,
  selectedRepos,
  onSelectRepository,
} : HybridProjectsServiceImportRepositoriesTableProps) => {
  return (
    <div className={styles.hybridTable}>
      <List>
        <List.Header>
          <span className={styles.column} />
          <span className={styles.column}>Title</span>
          <span className={styles.column}>Branch</span>
          <span className={styles.column}>Status</span>
        </List.Header>
        <List.Body>
          {
            repositories.map((repo: Repository) => {
              const isConnectable = (repo.connectableProjects?.length ?? 0) > 0;
              const isImported = !!repo.project;
              if (isImported) {
                return (
                  <ImportedProjectRow repo={repo} />
                );
              }
              if (isConnectable) {
                return (
                  <ConnectableProjectRow
                    repo={repo}
                    selectedRepos={selectedRepos}
                    onBranchChange={onBranchChange}
                    onSelectRepository={onSelectRepository}
                  />
                );
              }
              return (
                <UnimportedProjectRow
                  repo={repo}
                  onBranchChange={onBranchChange}
                  onSelectRepository={onSelectRepository}
                  selectedRepos={selectedRepos}
                />
              );
            })
          }
        </List.Body>
      </List>
    </div>
  );
};

export default HybridProjectsTable;
